import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'

/** Where a visit's status updates are sent. Status updates are text messages to a mobile number only. */
export interface VisitStatusUpdate {
    /** Mobile number formatted nnn-nnn-nnnn, or null when none is saved. */
    phone_number: string | null
    notify_using_phone: boolean
}

const statusUpdateTag = (visitId: string) => ({ type: 'Appointment' as const, id: `${visitId}:status-update` })

export const visitStatusUpdateApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getVisitStatusUpdate: builder.query<VisitStatusUpdate, string>({
            query: (visitId) => ({
                url: apiEndpoints.visits.statusUpdate(visitId),
                method: 'GET',
            }),
            providesTags: (_result, _error, visitId) => [statusUpdateTag(visitId)],
        }),
        updateVisitStatusUpdate: builder.mutation<VisitStatusUpdate, { visitId: string, phone: string }>({
            query: ({ visitId, phone }) => ({
                url: apiEndpoints.visits.statusUpdate(visitId),
                method: 'PUT',
                body: { phone },
            }),
            invalidatesTags: (_result, _error, { visitId }) => [statusUpdateTag(visitId)],
        }),
    }),
    overrideExisting: false,
})

export const { useGetVisitStatusUpdateQuery, useUpdateVisitStatusUpdateMutation } = visitStatusUpdateApi
